import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  Table,
  Space,
  Popconfirm,
  Modal
} from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined, FileSearchOutlined, SearchOutlined } from "@ant-design/icons";


//mobx
import { useStore } from "@/store";
import { observer } from "mobx-react-lite";
import { toJS, runInAction, set } from "mobx";
//mobx'

import DeviceInput from './DeviceInput'

const Device = () => {
  //mobx
  const { DeviceStore } = useStore();

  //获得table数据
  useEffect(() => {
    DeviceStore.getDataList();
    DeviceStore.getSelectList()
    DeviceStore.getSelectList2()
    DeviceStore.getSelectList3()
    // eslint-disable-next-line
  }, []);

  //分页控制
  const onPageChange = (page, pageSize) => {
    runInAction(() => {
      set(DeviceStore, { page: page, pagesize: pageSize })
    })
    DeviceStore.getDataList()
  }
  //分页控制

  //关闭X按钮
  const handleRevise = () => {
    runInAction(() => {
      set(DeviceStore, { isActive: false });
    });
  };

  //单个删除按钮
  const deleteConfirm = async (item) => {
    let id = toJS(item).aid;
    toJS(DeviceStore.dataList).filter((item) => item.aid !== id);
    await DeviceStore.getDeleteButtom(id);
  };

  //新增账户
  const getAddButton = (addTitle, data) => {
    if (addTitle === '编辑' || addTitle === '查看') {
      runInAction(() => {
        set(DeviceStore, { valueData: toJS(data) });
      })
    }
    runInAction(() => {
      set(DeviceStore, { title: addTitle, isActive: true });
    });
  };

  // 取消按钮
  const [form] = Form.useForm();


  //表单提交
  const onFinish = async (values) => {
    if (values.name) {
      runInAction(() => {
        set(DeviceStore, { sbmc: values.name, page: 1 })
      })
      await DeviceStore.getDataList();
    } else if (values.name === undefined || values.name === '') {
      runInAction(() => {
        set(DeviceStore, { sbmc: '', page: 1 })
      })
      await DeviceStore.getDataList();
    }

  };

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const start = async () => {

    setLoading(true);
    await DeviceStore.getDeleteButtom(toJS(DeviceStore.moreId));

    setTimeout(() => {
      setSelectedRowKeys([]);
      setLoading(false);
    }, 1000);
  };
  const onSelectChange = (newSelectedRowKeys) => {
    runInAction(() => {
      set(DeviceStore, { moreId: newSelectedRowKeys.toString() })
    })
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;

  //table 列表
  const columns = [
    {
      title: "ID",
      dataIndex: "aid",
    },
    {
      title: "所属系统",
      dataIndex: "xtmc",
    },
    {
      title: "所属企业",
      dataIndex: "qymc",
    },
    {
      title: "所属单元",
      dataIndex: "dymc",
    },
    {
      title: "设备编号",
      dataIndex: "sbbh",
    },
    {
      title: "设备名称",
      dataIndex: "sbmc",
    },
    {
      title: "设备型号",
      dataIndex: "sbxh",
    },
    {
      title: "生产企业",
      dataIndex: "scqy",
    },
    {
      title: "工作状态",
      dataIndex: "sbzt",
      render: (text) => text === 1 ? "启用" : "禁用"
    },
    {
      title: "操作",
      render: (item) => (
        <Space size="middle">
          <Button
            type="primary"
            icon={<FileSearchOutlined />}
            style={{ background: '#40ad63' }}
            onClick={() => getAddButton("查看", item)}
          >查看</Button>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => getAddButton("编辑", item)}
          >编辑</Button>
          <Popconfirm
            title="是否删除?"
            okText="确定"
            cancelText="取消"
            onConfirm={() => {
              deleteConfirm(item);
            }}
          >
            {<Button type="primary" icon={<DeleteOutlined />} danger>删除</Button>}
          </Popconfirm>

        </Space>
      ),
    },
  ];

  return (
    <>
      <div className="searchBox">
        <Form
          layout="inline"
          form={form}
          onFinish={onFinish}
        >
          <Form.Item label="关键词" name="name">
            <Input placeholder="请输入设备名称" style={{ width: "260px" }} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<SearchOutlined />} style={{ background: '#40ad63' }}>
              查询
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className="TableInput">
        <div className="buttonBox">
          <Popconfirm
            title="是否删除?"
            okText="确定"
            cancelText="取消"
            onConfirm={() => {
              start()
            }}
          >
            {<Button type="primary" icon={<DeleteOutlined />} style={{ background: '#6a8d9f', marginRight: '10px' }} disabled={!hasSelected} >
              批量删除
            </Button>}
          </Popconfirm>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            className="addTitle"
            onClick={() => getAddButton("添加", '')}
          >
            添加设备
          </Button>
        </div>
        <div className="total">共有数据:{DeviceStore.total}条</div>
      </div>

      <div className="contextNr">
        <Table
          rowKey={(record) => record.aid}
          columns={columns}
          dataSource={DeviceStore.dataList}
          rowSelection={rowSelection}
          className="table-box"
          pagination={{
            position: ["bottomCenter"],
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ['10', '20', '30'],
            pageSize: DeviceStore.pagesize,
            current: DeviceStore.page,
            total: DeviceStore.total,
            onChange: (page, pageSize) => onPageChange(page, pageSize),
          }}
        />
      </div>
      <Modal
        title={DeviceStore.title}
        key={new Date()}
        width="600px"
        open={DeviceStore.isActive}
        footer={null}
        onCancel={handleRevise}
      >
        <DeviceInput title={DeviceStore.title} />
      </Modal>
    </>
  );
};

export default observer(Device);
